// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eoev-app-conditional-date{height:2em;font-size:125%;font-weight:700}", ""]);
// Exports
module.exports = exports;
